/* eslint-disable */
export const initialStatsSummary = [
	{
		label: 'Total',
		value: 16140,
		icon: 'Hash',
	},
	{
		label: 'Passed',
		value: 16140,
		icon: 'CheckCircle',
	},
	{
		label: 'Overridden',
		value: 16140,
		icon: 'RefreshCcw',
	},
	{
		label: 'Failure',
		value: 16140,
		icon: 'XCircle',
	},
];

export const initialTabs = [
	{ key: 'sourcing', label: 'Sourcing', active: true },
	{ key: 'production', label: 'Production', active: false },
	{
		key: 'distribution',
		label: 'Distribution',
		active: false,
		disabled: true,
	},
];

export const initialAnalysisTabs = [
	{
		key: 'quantitative',
		label: 'Asset Quantitative',
		// icon: 'Settings',
		active: true,
	},
	{
		key: 'utilization',
		label: 'Utilization',
		// icon: 'Settings',
		active: false,
		disabled: true,
	},
	{
		key: 'maintenance',
		label: 'Maintenance',
		// icon: 'Settings',
		active: false,
		disabled: true,
	},
];

export const initialQCTypes = [
	{ key: 'dayEnd', label: 'Day End', active: true },
	{ key: 'stockMovement', label: 'Stock Movement', active: false },
];

export const initialConfigTypes = [
	{ key: 'time', label: 'Time', active: true },
	{ key: 'assetGroupWise', label: 'Asset', active: false },
	{ key: 'geography', label: 'Geography', active: false },
];

export const initialTimeRangesDropdown = [
	{ key: 'year', label: 'Month wise', active: false },
	{ key: 'quarter', label: 'Week wise', active: true },
	{ key: 'month', label: 'Day wise', active: false },
];
export const assetWiseDropdown = [
	{ key: 'assetCategory', label: 'Category Wise', active: true },
	{ key: 'assetType', label: 'Asset Type Wise', active: false },
	// { key: 'subCategory', label: 'Product Wise', active: false },
];
export const geographyWiseDropdown = [
	{ key: 'brand', label: 'Region wise', active: true },
	{ key: 'region', label: 'City wise', active: false },
	{ key: 'city', label: 'store wise', active: false },
];

export const initialFailureParameters = [
	{ key: 'all', label: 'All parameters', active: true },
];

export const machineParameters = [
	{
		key: 'temperature',
		label: 'Temperature',
		category: 'AI supervisor checks',
		active: false,
	},
	{
		key: 'weight',
		label: 'Weight',
		category: 'AI supervisor checks',
		active: false,
	},
	{
		key: 'visual',
		label: 'Visual Quality',
		category: 'AI supervisor checks',
		active: false,
	},
]

export const initialAnalysisData = {
	chartData: {
		labels: [],
		labelIds: [],
		datasets: [],
	},
	statsData: {
	},
};


export const initialStatisticalAnalysisData = {
	lineData: {},
	metricData: [],
	statsBoxData: [],
};


const tabVariants = {
	enter: {
		opacity: 0,
		y: 20,
	},
	center: {
		opacity: 1,
		y: 0,
	},
	exit: {
		opacity: 0,
		y: -20,
	},
};

const fadeVariants = {
	hidden: {
		opacity: 0,
		y: 10,
	},
	visible: {
		opacity: 1,
		y: 0,
	},
};

const timeFrameList = ['Daily','Week', 'Month', 'Custom'];


export { tabVariants, fadeVariants, timeFrameList };
